import { useState, useEffect } from "react";
import { fetchReferralConversationsData, type TimeRange, type ReferralConversationsData } from "@/app/services/analytics/referral-conversations-api";
import { useAnalyticsRefreshTrigger } from "./useAnalyticsRefreshTrigger";

export function useReferralConversationsData(
  timeRange: TimeRange,
  antennaData?: any,
  selectedModels?: string[],
) {
  const [data, setData]           = useState<ReferralConversationsData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState<Error | null>(null);
  const refreshKey                = useAnalyticsRefreshTrigger();

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    fetchReferralConversationsData(timeRange, antennaData, selectedModels)
      .then(r  => { if (!cancelled) { setData(r); setIsLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e instanceof Error ? e : new Error(String(e))); setIsLoading(false); } });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange, refreshKey]);

  return { data, isLoading, error };
}